module.exports = "<div ng-transclude></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/blocks/plainText/plainText.partial.html
// module id = 101
// module chunks = 0